import { useQueryClient } from "@tanstack/react-query";
import { ViaCep } from "../../../../services/ViaCep";

export const useBuscarCep = () => {
  const queryClient = useQueryClient();

  const buscarCep = (cep: string) => {
    return queryClient
      .fetchQuery({
        queryKey: ["via-cep", cep],
        queryFn: () => ViaCep.get(cep),
      })
      .then(({ data }) => data);
  };

  return { buscarCep };
};
